import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["answer"]

  toggle() {
    const answer = this.answerTarget
    const isOpen = this.element.classList.contains("open")

    if (isOpen) {
      answer.style.maxHeight = "0"
      this.element.classList.remove("open")
    } else {
      answer.style.maxHeight = answer.scrollHeight + "px"
      this.element.classList.add("open")
    }
  }
}
